/**
 * Container type helpers for quotation blocks (Fase 1).
 * Used by AdminQuotationBuilder and PDF worker; unit-tested for stability.
 */

import type { ContainerType } from './store-types';

export type { ContainerType };

/** Parse select value to ContainerType (20, 40, 20REF, 40REF). */
export function toContainerType(v: string): ContainerType {
  if (v === '20') return 20;
  if (v === '40') return 40;
  if (v === '20REF' || v === '40REF') return v;
  return 40;
}

/** Format for display in PDF and UI labels. */
export function formatContainerType(ct: ContainerType): string {
  if (ct === 20) return '20ft';
  if (ct === 40) return '40ft';
  if (ct === '20REF') return '20ft Refer';
  if (ct === '40REF') return '40ft Refer';
  return String(ct);
}
